export enum SeasonProperties {
  Name = "name",
  Description = "description",
  Media = "media",
  Owner = "owner",
  Id = "id",
  Created = "created",
  Updated = "updated",
  Deleted = "deleted",
  Version = "version",
  MediaStatus = "mediaStatus",
  SeriesId = "seriesId"
}
export enum SeasonMetaProperties {
  MediaId = "Media-id",
  MediaVersion = "Media-version"
}
